import type { GQL_ID } from '@@partner:types:graphql'
import type { Category, RsuiteItemDataType } from '@@partner:types:app'

import React, { useState, useEffect } from 'react'
import { useCategoriesFetcher } from '@@partner:graphql/query/catalog/categoriesWithParent.gql'

import { CheckTreePicker, TreePicker } from 'rsuite'
export interface CategoriesFilterrProps {
  skipIds?: GQL_ID[]
  value: GQL_ID[]
  onChange: (value: GQL_ID[]) => void
  multiple?: boolean
}

const mapToItemDataType = (category: Category) => ({
  label: category.name,
  value: category.id,
  children: [],
  loading: false,
  parent_id: category.parent_id,
  __category: category
})

export default function CategoriesFilter ({
  skipIds = [],
  value,
  onChange,
  multiple = true
}: CategoriesFilterrProps) {
  const [ data, setData ] = useState<RsuiteItemDataType[]>([])

  const { fetchCategories, fetchRootCategories } = useCategoriesFetcher()

  useEffect(() => {
    const preload = async () => {
      const initial = await fetchRootCategories({ skipIds })
      setData(initial.categories.edges.map(mapToItemDataType))
    }

    preload()
  }, [])

  const handleLoadRootCategories = async () => {
    const initial = await fetchRootCategories({ skipIds })
    setData(initial.categories.edges.map(mapToItemDataType))
  }

  const handleGetChildren = async (node: RsuiteItemDataType) => {
    if (node.value) {
      const data = await fetchCategories({
        parentId: node.value,
        skipIds
      })

      return data.categories.edges.map(mapToItemDataType)
    }

    return []
  }

  const handleChange = (category: RsuiteItemDataType) => {
    if (!multiple) {
      onChange(category.value ? [ category.value ] : [])
    }
    else {
      if (category.value && value?.includes(category.value)) {
        onChange(value.filter(cat => cat !== category.value))
      }
      else if (category.value) {
        onChange([
          ...value,
          category.value
        ])
      }
    }
  }

  const handleClear = () => {
    onChange([])
  }

  return (
    <div>
      {/* {JSON.stringify(data)} */}
      <CheckTreePicker
        block
        onOpen={handleLoadRootCategories}
        searchable={true}
        data={data}
        value={value}
        getChildren={handleGetChildren}
        onClean={handleClear}
        onSelect={handleChange}
        placeholder='Категории'
      />
    </div>
  )
}
